export const buttons = [
  {
    id: 1,
    title: 'Барча гуруҳлар',
    value: 'all',
  },
];
